import { H3, Small } from '@/components/sv/typographies'
import { Card, CardContent } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'

export const Overview = () => {
  return (
    <Card className="hidden lg:block">
      <CardContent>
        <div className="flex flex-col gap-4">
          <H3>Overview</H3>
          <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between">
              <Small>Base fee</Small>
              <Small className="font-medium">$40.00 / month</Small>
            </div>
            <Separator />
            <div className="flex items-center justify-between">
              <Small>Bandwidth</Small>
              <Small className="font-medium">$0.10 / GB</Small>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
